import React from 'react';
import { LANGS } from '../../hooks/useLanguage';
import { useTheme } from '../../context/ThemeContext';

export function LangSwitcher({ lang, setLang, enabledLanguages }) {
  const theme = useTheme();
  const { colors, isDark } = theme;

  const langs = enabledLanguages?.length
    ? LANGS.filter((l) => enabledLanguages.includes(l.code))
    : LANGS;
  if (langs.length <= 1) return null;

  return (
    <div style={{
      display: 'inline-flex', gap: '2px',
      backgroundColor: isDark ? '#1E1E1E' : colors.bgChip,
      borderRadius: '100px',
      padding: '3px',
      transition: 'background-color 0.3s',
    }}>
      {langs.map((l) => (
        <button
          key={l.code}
          onClick={() => setLang(l.code)}
          style={{
            padding: '5px 11px',
            borderRadius: '100px',
            border: 'none',
            backgroundColor: lang === l.code
              ? (isDark ? '#fff' : '#1A1A1A')
              : 'transparent',
            color: lang === l.code
              ? (isDark ? '#000' : '#fff')
              : colors.textSecondary,
            fontSize: '12px',
            fontWeight: '700',
            cursor: 'pointer',
            transition: 'all 0.18s',
            lineHeight: 1.4,
          }}
        >
          {l.flag} {l.label}
        </button>
      ))}
    </div>
  );
}
